// Settings management — persisted to localStorage
export interface Settings {
  soundEnabled: boolean;
  boardTheme: string;
  pieceStyle: string;
  showLegalMoves: boolean;
  showLastMove: boolean;
  difficulty: 'easy' | 'medium' | 'hard';
}

const SETTINGS_KEY = 'chesskid_settings';

const DEFAULT_SETTINGS: Settings = {
  soundEnabled: true,
  boardTheme: 'classic',
  pieceStyle: 'friendly',
  showLegalMoves: true,
  showLastMove: true,
  difficulty: 'easy',
};

export function loadSettings(): Settings {
  try {
    const stored = localStorage.getItem(SETTINGS_KEY);
    if (stored) {
      return { ...DEFAULT_SETTINGS, ...JSON.parse(stored) };
    }
  } catch {
    // corrupted storage, return defaults
  }
  return { ...DEFAULT_SETTINGS };
}

export function saveSettings(settings: Settings): void {
  localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
}

export function updateSetting<K extends keyof Settings>(key: K, value: Settings[K]): void {
  const settings = loadSettings();
  settings[key] = value;
  saveSettings(settings);
}
